// ABOUTME: Financial tab view listing invoice product categories with name + product count columns
// ABOUTME: Provides an add modal (MDynamicValues) and a sidepanel to rename/delete a category
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";

import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import {
    useGetInvoiceProductCategoryListQuery,
    useAddInvoiceProductCategoryMutation
} from "../../../../../newapi/financial/invoiceProductCategorySlice";
import { general_states } from "../../../../../utils/staticEnums";

import { WarehouseInvoiceProductCategoryCard } from "../../../../../components/global/cards/financial/InvoiceProductCategoryCard";
import MDynamicValues from "../../../../../components/global/Modals/MDynamicValues";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from "../../../../../components/theme/sidepanel2/SidepanelLoader";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../../utils/permissions";
import { useSelector } from "react-redux";
import { showToastMessagePostRequest } from "../../../../../utils/toasts";

const SpInvoiceProductCategoryDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpInvoiceProductCategoryDetails/SpInvoiceProductCategoryDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    return props.hasCreatePrivilege ?
        <ButtonGroup version={2}>
            <Shbutton
                className={"group-btn"}
                color={theme.palette.mode === "dark" ? "blue" : "primary"}
                onClick={() => props.handleOpen(true)}
                endIcon={<AddIcon/>}
                variant="contained"
            >
                {t('new_product_category')}
            </Shbutton>
        </ButtonGroup>
        : <></>;
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
};

const ProductCategories = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const hasCreatePrivilege = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.INVOICEPRODUCT_MANAGE])
    );

    const ref = useRef();
    const [config, setConfig] = useState({"state": general_states.ACTIVE});

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
        }
    },[props.config]);

    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleOpen = () => {
        setAddModalOpen(true);
    }

    const handleClose = () => {
        setAddModalOpen(false);
    };

    const [AddInvoiceProductCategory] = useAddInvoiceProductCategoryMutation();
    const handleConfirm = async (values) => {
        try {
            const response = await AddInvoiceProductCategory({
                name: values.name,
                state: general_states.ACTIVE,
            }).unwrap();
            showToastMessagePostRequest(t, response);
        } catch (err) {
            showToastMessagePostRequest(t, {success: false, error: err.error});
        }
    };

    const [invoiceProductCategoryId, setInvoiceProductCategoryId] = useState();
    const invoiceProductCategoryIdRef = useRef(invoiceProductCategoryId);

    const getInvoiceProductCategory = (params) => {
        if (!params) return;

        const newInvoiceProductCategoryId = parseInt(params.row.id);
        // Only update state if the id has actually changed
        if (invoiceProductCategoryIdRef.current !== newInvoiceProductCategoryId) {

            if(!spLoading) {
                setSpLoading(true);
            }
            setInvoiceProductCategoryId(newInvoiceProductCategoryId);
            invoiceProductCategoryIdRef.current = newInvoiceProductCategoryId;
        }
        setIsExtended(true);
    };

    const columns = [
        {
            field: "name",
            headerName: t("name"),
            flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return params.row.name;
            }
        },
        {field: "invoiceProducts", headerName: t("amount_of_products"),flex:1,
            sortable:false,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return params.row.invoiceProducts ? params.row.invoiceProducts.length : 0;
        }},
        {
            field: "phoneView",
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <WarehouseInvoiceProductCategoryCard
                        onClick={() => getInvoiceProductCategory(params)}
                        skeleton={params.row.skeleton}
                        {...params.row}
                    />
                )
            }
        }
    ];

    return (
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetInvoiceProductCategoryListQuery}
                config={config}
                gridActions={<GridActions handleOpen={handleOpen} hasCreatePrivilege={hasCreatePrivilege}></GridActions>}
                title={t('product_categories')}
                gridOptions={gridOptions}
                columns={columns}
                rows={data}
                onRowClick={getInvoiceProductCategory}
                sortModel={{field: columns[0].field,type:"ASC"}}
                >
            </ShDataGrid2>

            {spLoading &&
                    <SpInvoiceProductCategoryDetails
                        invoiceProductCategoryId={invoiceProductCategoryId}
                        isExtended={isExtended}
                        setIsExtended={setIsExtended}
                    />
            }

            <MDynamicValues
                open={addModal.open}
                handleClose={handleClose}
                title={"new_product_category"}
                labelWidth={80}
                fields={[
                    { name: "name", label: "name", type: "text", required: true },
                ]}
                onConfirm={handleConfirm}
            />
        </Box>
    );
}

export default ProductCategories;
